<template>
  <div v-if="className === 'image'" :style="contentStyle">
    <img :src="getSrc(item.value.properties.source[0])">
  </div>
  <div v-else class="notion" :class="className" :style="contentStyle">
    <div class="title-content" v-if="item.value.properties" v-html="title"></div>
    <notion v-for="child in item.children" :key="child.value.id" :item="child"></notion>
  </div>
</template>

<script>
  export default {
    name: "Notion",
    props: {
      item: Object
    },
    data() {
      return {}
    },
    methods: {
      getSrc(src) {

        return `https://launchpack.notion.site/image/${encodeURIComponent(src)}?table=block&id=${this.item.value.id}&spaceId=${this.item.value.space_id}&width=${this.item.value.format.block_width}&userId=&cache=v2`
      }
    },
    computed: {
      className() {
        return this.item.value.type === 'column' ? 'notion-column' : this.item.value.type;
      },
      title() {
        let title = '';
        if(this.item.value.properties && this.item.value.properties.title) {
          this.item.value.properties.title.forEach(i => {
            if(i.length === 1) {
              title += i[0];
            } else {
              if(i[1].length === 1) {
                title += `<span style="font-weight:500">${i[0]}</span>`;
              } else {
                title += `<${i[1][1]} class="${i[1][0][1]}">${i[0]}</${i[1][1]}>`;
              }
            }
          });
        }
        if(this.className === 'numbered_list') {
          title = '1. ' + title;
        }
        return title;
      },
      contentStyle() {
        let deco = {};
        if(this.item.value.format) {
          if(this.item.value.format.block_color) {
            let color = this.item.value.format.block_color.replace('_background','');
            if(color === 'gray') {
              deco.backgroundColor = 'rgb(241, 241, 239)';
            }
          }
          if(this.item.value.format.column_ratio && this.item.value.format.column_ratio !== 0.2) {
            deco.width = `calc(${this.item.value.format.column_ratio * 100}% - 12px)`;
          }
          else {
            deco.width = '100%';
          }
        }
        return deco;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .title-content
    white-space pre-line

  .column_list
    display flex
    flex-wrap wrap
    gap 24px
  .page
    .title-content
      margin-bottom 20px

  .notion-column
    .page
      .title-content
        font-size 24px
        font-weight 700
        margin-bottom 0

    .sub_sub_header
      margin 16px 0
      padding 8px

      .title-content
        font-size 16px
        font-weight 500

    .callout
      padding 16px 16px 16px 12px
      margin-bottom 20px
      .title-content
        font-size 14px
        font-weight 400

    .numbered_list
      .title-content
        font-size 16px
        font-weight 500
        margin-bottom 8px

    .text
      .title-content
        font-size 16px
        font-weight 400
        margin-bottom 8px

    .bulleted_list
      .title-content
        font-size 16px
        font-weight 400
        margin-bottom 8px
      .title-content::before
        content "•"
        margin-right 4px
      .text
        .title-content::before
          content unset


    .toggle
      .title-content
        font-size 16px
        font-weight 500
        margin-bottom 8px
      .text
        padding-left 8px
        .title-content
          font-size 15px
          font-weight 400
</style>
<style lang="stylus">
  .notion
    .b
      font-weight 600 !important
    .orange
      color rgba(217, 115, 13, 1)
</style>
